import {NgModule} from '@angular/core';
import {AuthModule, LogLevel} from 'angular-auth-oidc-client';


@NgModule({
    imports: [AuthModule.forRoot({
        config:
            [
                {
                    triggerAuthorizationResultEvent:true,
                    historyCleanupOff: true,
                    configId: 'CXone-Standard',
                    authority: 'https://cxone.niceincontact.com',
                    unauthorizedRoute: window.location.origin + '/unauthorized',
                    redirectUrl: (window.location.origin + '/post-login/index.html'),
                    postLogoutRedirectUri: window.location.origin + '/logout',
                    //clientId: 'NICEinContactDEVone3@NICEinContact Inc.',  Old Universal Auth
                    //clientId: 'NICEinContactDEVone10@NICEinContact Inc.',  Old Universal Auth
                    clientId: '4509ca3d-e2d5-4581-a789-169dffa81bee', //Fedramp Redirect is still bad.
                    scope: 'openid', // 'openid profile offline_access ' + your scopes
                    responseType: 'code',
                    customParamsAuthRequest: {display:'popup'},
                    silentRenew: true,
                    useRefreshToken: true,
                    autoUserInfo: false,
                    renewTimeBeforeTokenExpiresInSeconds: 1800,
                    logLevel: LogLevel.Debug,
                    disableIdTokenValidation: false
                },
                {
                    triggerAuthorizationResultEvent:true,
                    historyCleanupOff: true,
                    configId: 'CXone-Fedramp',
                    authority: 'https://cxone-gov.niceincontact.com',
                    unauthorizedRoute: window.location.origin + '/unauthorized',
                    redirectUrl: (window.location.origin + '/post-login/index.html'),
                    postLogoutRedirectUri: window.location.origin + '/logout',
                    clientId: 'NICEinContactDEVone3@NICEinContact Inc.',
                    scope: 'openid', // 'openid profile offline_access ' + your scopes
                    responseType: 'code',
                    customParamsAuthRequest: {display:'popup'},
                    silentRenew: true,
                    useRefreshToken: true,
                    autoUserInfo: false,
                    renewTimeBeforeTokenExpiresInSeconds: 1800,
                    logLevel: LogLevel.Debug,
                    disableIdTokenValidation: false
                }
            ]
    })],
    exports: [AuthModule],
})
export class AuthConfigModule {}
